import styled from 'styled-components';

export const Content = styled.div``;

/* The design's `.actionbar`, at dialog scale — see the floor form's copy. */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s2);
  margin-top: var(--s5);
  padding-top: var(--s4);
  border-top: 1px solid var(--line);
`;
